export const getTimeWord = (count: number, type: 'day' | 'hour' | 'minute' | 'second', t: any) => {
	switch (type) {
		case 'day':
			if (count % 10 === 1 && count % 100 !== 11) {
				return t('days.singular');
			} else if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
				return t('days.pair');
			} else {
				return t('days.plural');
			}

		case 'hour':
			if (count === 1) {
				return t('hours.singular');
			} else if (count >= 2 && count <= 4) {
				return t('hours.pair');
			} else {
				return t('hours.plural');
			}

		case 'minute':
			if (count === 1) {
				return t('minutes.singular');
			} else if (count >= 2 && count <= 4) {
				return t('minutes.pair');
			} else {
				return t('minutes.plural');
			}

		case 'second':
			if (count === 1) {
				return t('seconds.singular');
			} else if (count >= 2 && count <= 4) {
				return t('seconds.pair');
			} else {
				return t('seconds.plural');
			}

		default:
			return '';
	}
};
